import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const deliveryCostDict: Array<Dictionary> = []

for (const code of ['auto', 'manual']) {
    deliveryCostDict.push({
        code: code,
        name: i18n.t(`dictionary.deliveryCost.${code}`).toString()
    })
}

export { deliveryCostDict }
